/**
 * Subscription tiers, mirrored from facetflow `subscription.service.ts`.
 * The CRM never writes these; it only classifies what Facet Flow reports.
 */
export const TIERS = ['free', 'craft', 'workshop', 'atelier', 'business', 'business_plus'] as const;
export type Tier = (typeof TIERS)[number];

export const TIER_RANK: Record<Tier, number> = {
  free: 0,
  craft: 1,
  workshop: 2,
  atelier: 3,
  business: 4,
  business_plus: 5,
};

/** Legacy tier names still present on old credit documents. */
export const LEGACY_TO_NEW_TIER: Record<string, Tier> = {
  starter: 'craft',
  pro: 'workshop',
  studio: 'atelier',
};

/** Marketing display names. `business` is sold as "Studio" in copy. */
export const TIER_DISPLAY_NAME: Record<Tier, string> = {
  free: 'Free',
  craft: 'Craft',
  workshop: 'Workshop',
  atelier: 'Atelier',
  business: 'Studio',
  business_plus: 'Studio Plus',
};

export function normalizeTier(tier: string | null | undefined): Tier {
  if (!tier) return 'free';
  const lower = tier.toLowerCase();
  if ((TIERS as readonly string[]).includes(lower)) return lower as Tier;
  return LEGACY_TO_NEW_TIER[lower] ?? 'free';
}

export function tierRank(tier: string | null | undefined): number {
  return TIER_RANK[normalizeTier(tier)];
}

export const SUB_STATUSES = ['active', 'trialing', 'past_due', 'canceled', 'incomplete'] as const;
export type SubStatus = (typeof SUB_STATUSES)[number];
